<div class="bary-file-upload-visual">
  <div class="row">
    <div class="col div-image-upload">
      <!--<img *ngIf="_previewSrc" [src]="_previewSrc" alt="Image preview" class="img-fluid z-depth-1 rounded-circle"/>-->
      <div class="image-upload-logo" [class.circle]="displayCircle" [style]="_style" [class.image-background]="previewSrc || control.value">
        <div (click)="uploadFileVisual.click()">
          <mdb-icon *ngIf="!previewSrc && !control.value" fas [icon]="icon" [classInside]="'color-gray'" [size]="'4x'"></mdb-icon>
        </div>
        <a
          [mdbTooltip]="'entity.action.delete' | translate"
          *ngIf="previewSrc || control.value"
          (click)="deletePicture()"
          class="button-delete"
          mdbBtn
          [floating]="true"
          size="sm"
          color="danger"
        >
          <mdb-icon fas icon="times"></mdb-icon>
        </a>
      </div>
    </div>
  </div>

  <input hidden #uploadFileVisual [id]="id" type="file" name="uploadedFile" ng2FileSelect [uploader]="uploader" (onFileSelected)="checkFile($event)" />

  <div *ngIf="_errors.length > 0" class="alert alert-danger" role="alert">
    {{ _errors[0] }}
  </div>
</div>
